// Simple IndexedDB-based storage for users and devices
const DB_NAME = 'dbw-local';
const DB_VERSION = 1;
const STORE_USERS = 'users';
const STORE_DEVICES = 'devices';

type User = { walletId: string; createdAt: number };
type Device = { id: string; walletId: string; label: string; publicKeySpki?: string | null; createdAt: number };

function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE_USERS)) db.createObjectStore(STORE_USERS, { keyPath: 'walletId' });
      if (!db.objectStoreNames.contains(STORE_DEVICES)) db.createObjectStore(STORE_DEVICES, { keyPath: 'id' });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function upsertUser(user: User): Promise<void> {
  const db = await openDB();
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE_USERS, 'readwrite');
    tx.objectStore(STORE_USERS).put(user);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

export async function getUser(walletId: string): Promise<User | undefined> {
  const db = await openDB();
  return await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_USERS, 'readonly');
    const req = tx.objectStore(STORE_USERS).get(walletId);
    req.onsuccess = () => resolve(req.result as User | undefined);
    req.onerror = () => reject(req.error);
  });
}

export async function upsertDevice(device: Device): Promise<void> {
  const db = await openDB();
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE_DEVICES, 'readwrite');
    tx.objectStore(STORE_DEVICES).put(device);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

export async function getDevice(deviceId: string): Promise<Device | undefined> {
  const db = await openDB();
  return await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_DEVICES, 'readonly');
    const req = tx.objectStore(STORE_DEVICES).get(deviceId);
    req.onsuccess = () => resolve(req.result as Device | undefined);
    req.onerror = () => reject(req.error);
  });
}

export type { User, Device };


